var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',{staticClass:"banner"}),_vm._v(" "),_c('breadcrumb'),_vm._v(" "),_c('section',{staticClass:"tab flex container"},_vm._l((_vm.tab),function(item){return _c('a',{key:item.key,class:{'active':_vm.activeName===item.name},attrs:{"href":item.path}},[_vm._v(_vm._s(item.name))])}),0),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }